import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface ILabInventoryAuditState {
	data: Array<ILabInventoryAudit> | null;
	pageSize: number;
	pageNumber: number;
	totalCount: number;
	showLoading: ILoading;
	labInventoryAuditDetails: ILabInventoryAudit | null;
}

// Define the initial state using that type
const initialState: ILabInventoryAuditState = {
	data: null,
	pageSize: 0,
	pageNumber: 0,
	totalCount: 0,
	showLoading: {
		sourceAction: '',
		state: false,
	},
	labInventoryAuditDetails: null
};

export const labinventoryAuditSlice = createSlice({
	name: 'labInventoryAudit',
	// `createSlice` will infer the state type from the `initialState` argument
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.showLoading = {
				sourceAction: action.payload.sourceAction,
				state: true,
			};
		},
		resetLoading: (state, action) => {
			state.showLoading = {
				sourceAction: '',
				state: false,
			};
		},
		replaceItems: (state, action) => {
			const { data, pageSize, pageNumber, totalCount } = action.payload;

			state.data = data;
			state.pageSize = pageSize;
			state.pageNumber = pageNumber;
			state.totalCount = totalCount;
		},
		setlabInventoryAuditDetails: (state, action) => {
			state.labInventoryAuditDetails = action.payload.data;
		}
	},
});

export const labInventoryAuditActions = labinventoryAuditSlice.actions;

export default labinventoryAuditSlice.reducer;
